// extracted by mini-css-extract-plugin
export default {"spin":"Detail_spin__Qjinv"};